import React, { useRef } from 'react';
import { Image, StyleSheet, Text, TouchableOpacity, PixelRatio, ImageSourcePropType } from 'react-native';
import { useHover } from 'react-native-web-hooks';
import useFontSize from '../shell/hooks/useFontSize';
import ImageClass from '../shell/Image';
import { UIINT } from '../shell/UI';
import { isMobile } from '../shell/utils/platformCheck';

interface TUIButtonProps {
    size: number,
    onButtonPressed: (ui: UIINT) => void,
    ui: UIINT;

}

export const TUIButton: React.FC<TUIButtonProps> = ({ size, onButtonPressed, ui }) => {
    const ref = useRef(null);
    const isHovered = useHover(ref);
    const styles = StyleSheet.create({
        container: {
            position: "absolute",
            bottom: "5%",
            left: size,
            flexDirection: "row"
            // width: "30%",
        },
        uiWrapper: {
            // position: "absolute",
            height: size,
            width: size,
            display: "flex",
            alignItems: "center",
        },
        uiStyle: {

            // position: "absolute",
            resizeMode: 'cover',
            height: size,
            width: size,

        },
        tooltip: {
            width: 300 / PixelRatio.get(),
            color: "white",
            position: "absolute",
            top: -30,
            fontSize: useFontSize(1.5),
            alignSelf: "center",
            justifyContent: "center",
            alignContent: "center",
            alignItems: "center",
            textAlign: "center"

        }
    });
    const handleOnClick = (ui: UIINT) => {
        if (onButtonPressed) {
            onButtonPressed(ui);
        }
    };

    return (
        <TouchableOpacity ref={ref} style={styles.uiWrapper} onPress={() => handleOnClick(ui)}>
            <Image source={ImageClass._globalImages.get(ui.image.key)?.url || ui.image.url || (ui.image as ImageSourcePropType)} style={[styles.uiStyle]} />
            <Text adjustsFontSizeToFit style={[styles.tooltip, { opacity: isHovered || isMobile() ? 1 : 0 }]}>{ui.tooltip}</Text>
        </TouchableOpacity>
    );
};